module.exports = __webpack_public_path__ + "img/1.62d00c24.jpg";